exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrap[data-v-55b6b76f]{position:absolute;left:0;right:0;top:0;bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n.no-data>img[data-v-55b6b76f]{width:120px\n}\n.no-data>p[data-v-55b6b76f]{height:30px;line-height:40px;text-align:center;color:#999;font-size:14px\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55b6b76f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"/home/yan3/jenkins-agent/workspace/MARKING_VUE_REGION_FRONTEND_BUILD/src/assets/styles/variable.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/nodata/NoData.vue
// module id = YV0N
// module chunks = 129